import {useContext, useState, createContext, useEffect, useCallback} from "react"

import {AuthContext} from "../security/AuthContext";

const pictureContext = createContext();

// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvidePictures({ children }) {
    const pictureData = useProvidePicture();
    return <pictureContext.Provider value={pictureData}>{children}</pictureContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const usePicture = () => {

    return useContext(pictureContext);
};

// Provider hook that creates auth object and handles state
function useProvidePicture() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { user} = useContext(AuthContext);
   const [pictures,setPictures] = useState([]);



   const getPictures = useCallback(() => {

       const load = async  () =>{
           try {
               console.log('load pictures');
               console.time("fetch pictures x1");
               fetch('/.netlify/functions/getPictures')
                   .then((response) => response.json())
                   .then(data => {

                       setPictures(data.sort((a, b) => a.title.localeCompare(b.title)));
                       }
                   )

                   .catch(err => {
                           console.log("Error", err);
                           setError(err);
                       }
                   )

           } catch (err) {
               setError(err.response);
           } finally {
               setLoading(false);
           }
       }

       if (pictures.length === 0) {
           load();
       }
       return pictures;

   }, [pictures])

    useEffect(() => {
        getPictures();
    }, [getPictures]);



    const save = (picture) => {
        console.log("Save Picture",picture)
        setError(null)


        return fetch("/.netlify/functions/upsertPicture",
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.token?.access_token}`
                },
                method: "POST",
                body: JSON.stringify(picture)
            })
            .then((res) => {
                    if (res.ok) {

                        return res.json();
                    }
                    return Promise.reject(Object.assign({}, res, {
                        status: res.status,
                        statusText: res.statusText,
                    }));
                }
            ).then((responseJson) => {
                setPictures([]);
                console.log('Response', responseJson)
        })
            .catch((err) => {
                console.log('error',err);
                setError(err);
            });



    }


    const initialState = {id: null,
        data: '',
        tagLine: '',
        createDate: null};

    const create = () => {

        setError(null);
        setLoading(false);
        return initialState;
    }



    const remove = async (id) => {
        console.log('Delete',id)
        fetch('/.netlify/functions/deletePicture/' + id,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.token?.access_token}`
                },
                method: "DELETE",
            })
            .then((res) => {
                    if (res.ok) {
                        return res.json();
                    }
                    return Promise.reject(Object.assign({}, res, {
                        status: res.status,
                        statusText: res.statusText,
                    }));
                }
            ).then(() => {
                setPictures([]);
        })
            .catch((err) => {
                console.log('error',err);
                setError(err);
            });
    }

    const isError = () => {
        return ! (error===null)
    }



    return {
        save,
        getPictures,
        create,
        remove,
        isError,
        error,
        loading
    }


}




